import {IEnhancerReel, ISpecialSymbolData, ITheRaveData, ITheRaveGameData} from "./ITheRaveData";
import {TheRaveDataParser} from "./TheRaveDataParser";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {TheRaveGameMode} from "../../gameflow/TheRaveGameMode";
import {TheRaveGameConfig} from "../../TheRaveGameConfig";

export abstract class TheRaveParsedData {
    public readonly mode: string;
    public readonly nextMode: string;
    public readonly reels: string[][];
    public readonly nextReelSetName: string;
    public readonly totalWin: number;
    public readonly currentMultiplier: number;
    public readonly scatterPositions: number[];
    public readonly freespinsLeft: number;
    public readonly freespinTriggeredThisSpin: boolean;
    public readonly numberOfFreespinsPlayed: number;
    public readonly showTotalWin: boolean;
    public readonly reelSizes: number[];
    public readonly lastSpinReelId: number;
    public readonly freespinMidMultipliers: number[];
    public readonly scatterEnhancers: IEnhancerReel[];
    public readonly enhancerReel: boolean[];
    public readonly splitDataListxWays: ISpecialSymbolData[];

    constructor(rawData: ITheRaveData, parser: TheRaveDataParser) {
        //console.log(rawData);
        this.mode = rawData.mode;
        this.nextMode = rawData.nextMode;
        this.reels = parser.parseReels(rawData);
        this.nextReelSetName = TheRaveGameConfig.getReelSetName(this.nextMode);
        this.currentMultiplier = rawData.currentMultiplier != null ? rawData.currentMultiplier : 1;
        this.totalWin = rawData.accumulatedRoundWin != null ? rawData.accumulatedRoundWin : 0;
        this.freespinMidMultipliers = rawData.freespinMidMultipliers;
        this.splitDataListxWays = rawData.splitDataListxWays;

        this.freespinsLeft = rawData.freespinsLeft != null ? rawData.freespinsLeft : 0;
        this.freespinTriggeredThisSpin = rawData.freespinTriggeredThisSpin!;
        this.numberOfFreespinsPlayed = rawData.numberOfFreespinsPlayed != null ? rawData.numberOfFreespinsPlayed : 0;
        this.showTotalWin = this.parseShowTotalWin();
        this.reelSizes = [3, 3, 3, 3, 3];
        this.scatterPositions = rawData.scatterPositions;
        this.scatterEnhancers = this.getEnhancerReelData(rawData.scatterEnhancers);
        this.enhancerReel = this.getEnhancerReel(rawData.scatterEnhancers);
        this.lastSpinReelId = (this.isFreespinMode(rawData.mode)?4:this.getLastSpinReelId(this.enhancerReel));
    }

    private getLastSpinReelId(enhancerReel: boolean[]): number {
        let lastSpinReelId: number = 4;
        enhancerReel.forEach((hasEnhancer: boolean, i: number) => {
            if (hasEnhancer) {
                lastSpinReelId = (i + 5);
            }
        });
        return lastSpinReelId;
    }

    private getEnhancerReelData(reels: string[][]): IEnhancerReel[] {
        let enhancerReels: IEnhancerReel[] = [];
        reels.forEach((data: string[], i: number) => {
            enhancerReels.push({
                reelId: parseInt(data[0]),
                symbolId: parseInt(data[1]),
                symName: data[2],
            })
        });
        return enhancerReels;
    }

    private getEnhancerReel(scatterEnhancers: string[][]): boolean[] {
        let temp: boolean[] = [false, false, false, false, false];
        scatterEnhancers.forEach((scatterEnhancer: string[], i: number) => {
            temp[parseInt(scatterEnhancer[0])] = true;
        });
        return temp;
    }

    protected parseShowTotalWin(): boolean {
        return this.isFreespinMode(this.mode) || this.isFreespinMode(this.nextMode);
    }

    private isFreespinMode(mode: string): boolean {
        return mode === GameMode.FREESPIN || mode === TheRaveGameMode.FREESPIN_SUPER;
    }
}